import { render } from "./BuildingsEffectA.vue?vue&type=template&id=5efb6db1&scoped=true"
import script from "./BuildingsEffectA.vue?vue&type=script&lang=js"
export * from "./BuildingsEffectA.vue?vue&type=script&lang=js"

import "./BuildingsEffectA.vue?vue&type=style&index=0&id=5efb6db1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5efb6db1"]])

export default __exports__